module.exports = __webpack_public_path__ + "static/media/lastschriftlogo.597e4a17.png";